import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { PIN_LENGTH, PinInput } from "./PinInput";
import { LinkButton } from "./LinkButton";
import { Screen, ScreenBody, ScreenTitle } from "./Screen";

export interface ChoosePinProps {
  onComplete(pin: string): void;
  onSkip(): void;
  disabled?: boolean;
}

export const ChoosePin: React.FC<ChoosePinProps> = ({
  onComplete,
  onSkip,
  disabled,
}) => {
  const { t } = useTranslation();
  const [entry, setEntry] = useState({ digits: "", mismatch: false });
  const confirming = entry.digits.length >= PIN_LENGTH;
  const first = entry.digits.slice(0, PIN_LENGTH);
  const value = confirming ? entry.digits.slice(PIN_LENGTH) : entry.digits;

  const onChange = (next: string) => {
    const digits = (confirming ? first : "") + next;
    const complete = digits.length === PIN_LENGTH * 2;
    if (complete && next !== first) {
      setEntry({ digits: "", mismatch: true });
      return;
    }
    setEntry({ digits, mismatch: false });
    if (complete) onComplete(next);
  };

  return (
    <Screen testId="login-choose-pin">
      <ScreenTitle>
        {confirming ? t("Confirm your PIN") : t("Choose a PIN")}
      </ScreenTitle>
      <ScreenBody>
        {confirming
          ? t("Enter the same 4 digits again.")
          : t("Pick 4 digits you will remember. Used on this device only.")}
      </ScreenBody>
      <PinInput
        value={value}
        onChange={onChange}
        error={
          entry.mismatch
            ? t("Those PINs did not match. Start again.")
            : undefined
        }
        disabled={disabled}
      />
      <LinkButton onClick={onSkip} disabled={disabled}>
        {t("Skip for now")}
      </LinkButton>
    </Screen>
  );
};
